import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextBreak } from 'flow-builder/node/textBreak';
import { TextContent } from 'flow-builder/node/textContent';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { ForwardModal } from '../../modals/forward';
import { CallPattern } from '../../types';
const translatePayload = (node) => {
    const { noAnswerNodeId } = node.payload;
    return noAnswerNodeId
        ? [
            {
                id: uuid(),
                connection: noAnswerNodeId,
                label: 'No answer',
            },
        ]
        : [];
};
const updateConnection = (node, connection, connectionId) => {
    const payload = Object.assign({}, node.payload);
    if (connection.connectionLabel === 'No answer') {
        payload.noAnswerNodeId = connectionId;
    }
    return Object.assign(Object.assign({}, node), { payload });
};
export const ForwardNodeAttributes = {
    iconName: 'phone-outgoing',
    label: 'Forward',
    helpText: 'Set up incoming calls to be forwarded to internal or external phone numbers.',
    color: hexStringToNumber(flowNodeColor.green),
    translatePayload,
    updateConnection,
    NodeContent: ForwardNode,
    ActionModal: ForwardModal,
};
export function ForwardNode({ node }) {
    const { payload } = node;
    const { numbers } = payload;
    const pattern = payload.callPattern === CallPattern.Sequence
        ? 'Sequence'
        : 'First to pick up';
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(TextBreak, { children: [_jsx(Text, { weight: "normal", text: "Call pattern" }), _jsx(Text, { weight: "semibold", text: `${pattern},` }), _jsx(Text, { weight: "normal", text: "to" }), _jsx(Text, { weight: "semibold", text: `${numbers.length} ${numbers.length === 1 ? 'phone' : 'phones'}` })] })), [pattern, numbers.length]) }));
}
